// src/AudioSpectrum/effects/butterflyFountain.js
import { getHSLColor } from '../colorUtils.js';

export const drawButterflyFountain = (ctx, frequencyData, width, height, fountainRef) => {
  ctx.fillStyle = 'rgba(5, 15, 25, 0.06)';
  ctx.fillRect(0, 0, width, height);
  
  const fountainCount = 5;
  const fountainWidth = width / (fountainCount - 1);
  const time = Date.now();
  
  for (let f = 0; f < fountainCount; f++) {
    const fountainX = (f + 0.5) * fountainWidth;
    const freqStart = Math.floor((f / fountainCount) * frequencyData.length);
    const freqEnd = Math.floor(((f + 1) / fountainCount) * frequencyData.length);
    const avgValue = frequencyData.slice(freqStart, freqEnd).reduce((a, b) => a + b, 0) / (freqEnd - freqStart);
    
    if (avgValue > 45 && Math.random() < 0.3) {
      const butterflyCount = Math.floor(avgValue / 50);
      for (let i = 0; i < butterflyCount; i++) {
        fountainRef.current.push({
          x: fountainX + (Math.random() - 0.5) * 25,
          y: height - 60,
          vx: (Math.random() - 0.5) * 2,
          vy: -(avgValue / 255) * 6 - Math.random() * 2,
          life: 1.0,
          decay: 0.003,
          size: Math.random() * 2 + 4.5,
          color: getHSLColor(Math.random() * 360, 80, 65),
          gravity: 0.015,
          wingPhase: Math.random() * Math.PI * 2,
          wingSpeed: 0.3 + Math.random() * 0.2,
          flightPattern: Math.random() * Math.PI * 2,
          type: 'butterfly'
        });
      }
    }
  }
  
  // 나비 파티클 업데이트
  fountainRef.current = fountainRef.current.filter(particle => {
    // 나비의 비행 패턴
    const flightTime = (time - (particle.birthTime || time)) * 0.001;
    const flightX = Math.sin(flightTime * 2 + particle.flightPattern) * 2;
    const flightY = Math.cos(flightTime * 1.5) * 1;
    
    particle.x += particle.vx + flightX;
    particle.y += particle.vy + flightY;
    particle.vy += particle.gravity;
    particle.life -= particle.decay;
    particle.wingPhase += particle.wingSpeed;
    
    if (particle.life > 0 && particle.y < height + 30) {
      ctx.globalAlpha = particle.life;
      ctx.save();
      ctx.translate(particle.x, particle.y);
      
      // 날개짓 효과
      const wingScale = 0.8 + Math.sin(particle.wingPhase) * 0.3;
      
      // 나비 그리기
      ctx.fillStyle = particle.color;
      
      // 윗날개
      ctx.beginPath();
      ctx.ellipse(-particle.size * 0.7, -particle.size * 0.3, 
                particle.size * wingScale, particle.size * 0.8 * wingScale, 
                -0.3, 0, Math.PI * 2);
      ctx.fill();
      
      ctx.beginPath();
      ctx.ellipse(particle.size * 0.7, -particle.size * 0.3, 
                particle.size * wingScale, particle.size * 0.8 * wingScale, 
                0.3, 0, Math.PI * 2);
      ctx.fill();
      
      // 아랫날개
      ctx.beginPath();
      ctx.ellipse(-particle.size * 0.5, particle.size * 0.3, 
                particle.size * 0.6 * wingScale, particle.size * 0.5 * wingScale, 
                0.2, 0, Math.PI * 2);
      ctx.fill();
      
      ctx.beginPath();
      ctx.ellipse(particle.size * 0.5, particle.size * 0.3, 
                particle.size * 0.6 * wingScale, particle.size * 0.5 * wingScale, 
                -0.2, 0, Math.PI * 2);
      ctx.fill();
      
      // 몸통
      ctx.fillStyle = '#4a4a4a';
      ctx.beginPath();
      ctx.ellipse(0, 0, particle.size * 0.1, particle.size, 0, 0, Math.PI * 2);
      ctx.fill();
      
      ctx.restore();
      ctx.globalAlpha = 1.0;
      return true;
    }
    return false;
  });
};